import React from "react";
import { Link } from "react-router-dom";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import '../components/css/CourseStyle.css';
import Footer from '../components/Footer';
import tag from '../components/images/onlineTag.webp';
import banners from '../components/courses/bsc-chemisterycour.png';

function IITGate (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            
            <section className="bg-red text-white">
                <img src={banners} className="courseBanner" alt="" />
            </section>

            <section className="py-3">
                <div className="container">
                    <nav aria-label="breadcrumbs">
                        <ol className="breadcrumbs">
                            <li className="breadcrumbs-item itemslist"><Link to="/"><i className="bi bi-house"></i></Link></li>
                            <li className="breadcrumbs-item active" aria-current="page">IIT GATE Exam</li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="mb-5">
                        <h2 className="fw-bold">IIT GATE Exam</h2>
                        <p className="text-muted">Discover all the essential details on the GATE 2026 Exam including notification, registration, other important dates, eligibility, syllabus, exam pattern, courses, books and more here. Join our online courses to boost your preparation for GATE 2026 & GATE 2027</p>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-blue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-display fs-3"></i></div>
                                    <h5 className="fw-bold">Blogs</h5>
                                    <p className="text-muted mb-0">Read Our Latest Blogs</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-pink">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-journal-text fs-3"></i></div>
                                    <h5 className="fw-bold">Online Courses</h5>
                                    <p className="text-muted mb-0">Access Our Latest Courses</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-green">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-clipboard-check fs-3"></i></div>
                                    <h5 className="fw-bold">Test Series</h5>
                                    <p className="text-muted mb-0">Practice with Our Mock Test</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-lightblue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-book fs-3"></i></div>
                                    <h5 className="fw-bold">Books</h5>
                                    <p className="text-muted mb-0">Find Preparation Books</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container my-5">    
                <h3 class="fw-bold mb-4">IIT GATE Courses</h3>
                <div class="row g-4">
                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-12-09-0_3081632293744353.jpg" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/super-100-iit-gate-2027" class="text-dark" target="_blank">GATE 2027 - S100 Pro LIVE</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>6 months</b></li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹11,999</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Live Interactive Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get c</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/super-100-iit-gate-2027" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-12-09-0_5380221753512384.jpg" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-gate-2027-basic-2-advance" class="text-dark" target="_blank">IIT GATE 2027 Basic to Advance</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>6 months</b></li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹11,999</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Live Interactive Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get c</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-gate-2027-basic-2-advance" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-12-09-0_9745024388041521.jpg" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-gate-2027-rec" class="text-dark" target="_blank">IIT GATE 2027 Rec.</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>6</b></li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹10,999</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-gate-2027-rec" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-12-09-0_777734788116895.jpg" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/p-gate-2027" class="text-dark" target="_blank">Physical Chemistry IIT GATE 2027</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>6 months</b></li>
                                </ul>
                                <div class="batch-strip my-2">Physical Chemistry CSIR June 26 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹4,999</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/p-gate-2027" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-12-09-0_705290559722286.jpg" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/o-gate-2027" class="text-dark" target="_blank">Organic Chemistry IIT GATE 2027</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>6 month</b></li>
                                </ul>
                                <div class="batch-strip my-2">Organic Chemistry CSIR June 2026 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹4,999</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/o-gate-2027" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-12-09-0_39135224916966416.jpg" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/i-gate-2027" class="text-dark" target="_blank">Inorganic Chemistry IIT GATE 2027</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>6 month</b></li>
                                </ul>
                                <div class="batch-strip my-2">Inorganic Chemistry CSIR June 2026 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹4,999</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/i-gate-2027" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <Link to="#" class="btn btn-light border rounded-pill px-4 py-2 text-primary fw-semibold">View All Batches <i class="bi bi-arrow-right"></i></Link>
                </div>
            </section>

            <section className="container coursebox py-3">
                <div class="row g-4">
                    <h3>IIT GATE Exam</h3>
                    <p>IIT GATE is a crucial exam for aspiring research scholars and scientists. It assesses candidates' knowledge in subjects like Chemical Sciences, Earth Sciences, Life Sciences, Mathematical Sciences, and Physical Sciences. The test comprises multiple-choice questions evaluating research aptitude and subject-specific knowledge.</p>

                    <h3>What is IIT GATE?</h3>
                    <p>GATE 2026: The Graduate Aptitude Test in Engineering (GATE) is a prestigious national-level entrance examination in India that assesses the knowledge of candidates in various engineering and science subjects. The GATE Examination, which is held annually on a rotational basis by a committee of seven IITs and IISc Banglore, is one of the most challenging entrance tests that allows aspirants to pursue higher education programs at prominent IITs and offers PSU jobs. IIT Guwahati intends to organize the GATE 2026 examination in the upcoming academic year.</p>
                    <p>The GATE exam serves as the gateway to obtain admissions to postgraduate programs and PSU recruitments through GATE. It is a highly competitive exam, making it essential for aspirants to prepare diligently. If you are wondering "when is the next GATE exam," all the latest updates on GATE Official Website.</p>
                    <p>Passing the GATE exam with a significant score facilitates admission into postgraduate programs and job opportunities in PSUs.</p>
                    <p>Students preparing for GATE 2026/2027 require a strategic approach, including understanding the exam pattern, and syllabus, and utilizing exam-oriented study materials.</p>
                    <p>Second and third year candidates can start their preparation with Physics Wallah because we are providing dedicated batches for GATE 2026 & GATE 2027 so that candidates can start their preparation early.</p>

                    <h3>IIT GATE Exam Details </h3> 
                    <p>It is anticipated that GATE 2026 will be conducted for 30 subjects. However, if the inclusion of any new subject happens, the exam-conducting authority will make an announcement regarding the same, which applicants can find on this web page. Meanwhile, check out the IIT Guwahati GATE 2026 overview tabulated below.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th colSpan={2}>GATE 2026 Exam Overview</th>
                            </tr>
                            <tr>
                                <td>Examination Name</td>
                                <td>GATE 2026</td>
                            </tr>
                            <tr>
                                <td>GATE Full Form</td>
                                <td>Graduate Aptitude Test in Engineering</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Conducting Body</td>
                                <td>IIT Guwahati</td>
                            </tr>
                            <tr>
                                <td>GATE 2025 Notification</td>
                                <td>August 21, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Online Registration Commencement</td>
                                <td>August 28, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Apply Online Last date Without Late Fees</td>
                                <td>September 28, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Registration Last Date With Late Fees</td>
                                <td>October 9, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Exam Date</td>
                                <td>February 7, 8, 14, 15, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Result Date</td>
                                <td>March 19, 2025</td>
                            </tr>
                            <tr>
                                <td>Purpose of GATE 2026 Examination</td>
                                <td>Offering Admission to Higher Education (M.E./ M.Tech/ and Ph.D. Courses)</td>
                            </tr>
                            <tr>
                                <td>Application Mode</td>
                                <td>Online</td>
                            </tr>
                            <tr>
                                <td>Exam Mode</td>
                                <td>Computer-Based-Test (CBT)</td>
                            </tr>
                            <tr>
                                <td>Duration of Exam</td>
                                <td>180 Minutes (3 Hours)</td>
                            </tr>
                            <tr>
                                <td>Number Of Questions</td>
                                <td>65</td>
                            </tr>
                            <tr>
                                <td>Exam Frequency</td>
                                <td>Once a Year</td>
                            </tr>
                            <tr>
                                <td>Number of GATE Papers</td>
                                <td>30</td>
                            </tr>
                            <tr>
                                <td>GATE Admit Card 2026</td>
                                <td>January 2026 (Expected)</td>
                            </tr>
                            <tr>
                                <td>Validity of GATE Score</td>
                                <td>3 Years</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Official website</td>
                                <td>https://gate2026.iitg.ac.in/</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3>GATE 2026 Notification</h3>
                    <p>The GATE 2026 Notification is released by IIT Guwahati on August 21, 2025. It will include all the essential details such as eligibility criteria, exam dates, syllabus, registration process, and other key guidelines for applicants. Candidates aspiring to appear for the GATE 2026 exam should regularly check the official website, and this page for timely updates. As notification is released, the officials will also activate the GATE 2026 Application Form  link soon (Aug 28), allowing students to begin their registration process through the GOAPS portal.</p>
                    <p className="text-center text-danger">GATE 2026 Information Brochure</p>
                    <h3>GATE 2026 Registration Process</h3>
                    <p>The GATE Registration 2026 now starting from August 28 to October 9, 2025 right after the announcement of the notification by IIT Guwahati. Applicants can then use the activated GATE 2026 Apply Online Link in order to register their personal and educational details. Take a look at the easy-to-follow steps outlined below to make the GATE 2026 Registration process smooth and hassle-free. Step 1: Registration in the GOAPS Web Portal</p>
                    <p>
                        <ul className="list-unstyled">
                            <li>Aspirants must start by registering their personal details, like name, email ID, phone number, etc., in order to obtain GATE Login 2026 credentials, which will be their enrollment ID and password.</li>
                        </ul>
                    </p>
                    <p className="mb-3">Step 2: Login to Fill Out the GATE 2026 Application Form</p>
                    <p>
                        <ul className="list-unstyled">
                            <li>The application form will be available on the GATE 2026 Official Website. Applicants by using their enrollment ID and password, can access the GATE 2026 Application Form to enter the required details.</li>
                        </ul>
                    </p>
                    <p>
                        <ul className="list-unstyled">
                            <li>Uploading the scanned photograph and signature of the applicant is mandatory when filling out the GATE 2026 Application Form. Additionally, to complete the application procedure, paying the application fee through the given online payment mode is crucial.</li>
                        </ul>
                    </p>

                    <h3>GATE 2026 Exam Dates</h3>
                    <p>The Indian Institute of Technology, Guwahati, will announce the GATE 2026 Exam Date calendar for all the examination events, from registration commencement to scorecard release date. As soon as the authorities announce the newly scheduled GATE 2026 Exam Dates, applicants will be able to locate them in the table below.</p>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>GATE 2026 Exam Date Schedule</td>
                            </tr>
                            <tr>
                                <td>Particulars</td>
                                <td>Exam Dates</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Online Application Processing System (GOAPS) Activation</td>
                                <td>August 28, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Last Date to Register Online (Without Late Fee)</td>
                                <td>September 28, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Last Date to Register Online (With Late Fee)</td>
                                <td>October 9, 2025</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Application Modification Window</td>
                                <td>November 2025, Expected</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Admit Card Release Date</td>
                                <td>January 2026, Expected</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Exam Date</td>
                                <td>February 7, 8, 14, 15, 2026</td>
                            </tr>
                            <tr>
                                <td>Availability of GATE 2026 Response Sheet</td>
                                <td>February 2026, Expected</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Answer Key Release Date</td>
                                <td>February 2026, Expected</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Answer Key Challenge Window Activation</td>
                                <td>February 2026, Expected</td>
                            </tr>
                            <tr>
                                <td>GATE Result 2026 Announcement</td>
                                <td>March 19, 2026</td>
                            </tr>
                            <tr>
                                <td>GATE Scorecard 2026 Availability</td>
                                <td>March 27, 2026 to May 31, 2026 (Free), June 01, 2026 to December 31, 2026 (INR 500)</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>GATE 2026 Eligibility Criteria</h3>
                    <p>While the IIT Guwahati releases the GATE 2026 Eligibility Criteria released in August 2025 along with an information brochure, aspirants who are planning to appear for the exam can review the eligibility requirements from previous years here, as GATE usually follows similar eligibility criteria every year.</p>
                    <ul className="list-unstyled">
                        <li>GATE 2026 Educational Qualifications Requirements: Aspirants should have passed or be in the final or third year of their bachelor’s degree in engineering, technology, architecture, science, or the humanities from a government-approved university or institution.</li>
                        <li>GATE 2026 Nationality: All Indian citizens, along with international countries, can apply if they fulfill the eligibility criteria.</li>
                        <li>GATE 2026 Age Limit: Applicants from all age groups can appear for the Graduate Aptitude Test in Engineering examination, as GATE does not set any age limit restrictions.</li>
                    </ul>

                    <h3>GATE 2026 Exam Pattern</h3>
                    <p>IITG or the Indian Institute of Technology, Guwahati, will publish the GATE 2026 Exam Pattern. It can be seen that the Graduate Aptitude Test in Engineering follows a similar exam pattern every academic year, which consists of a total of 65 questions worth 100 marks. Take a look at the expected GATE 2026 Exam Pattern outlined below as per the past examination trend.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>GATE 2026 Exam Pattern</td>
                            </tr>
                            <tr>
                                <td>Particulars</td>
                                <td>Details</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Examination Mode</td>
                                <td>Computer Based Test (Online)</td>
                            </tr>
                            <tr>
                                <td>Duration of Exam</td>
                                <td>3 Hours</td>
                            </tr>
                            <tr>
                                <td>Number of Papers in GATE 2026</td>
                                <td>30 Papers</td>
                            </tr>
                            <tr>
                                <td>Sections in GATE 2026 Question Paper</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>General Aptitude (GA)</li>
                                        <li>Engineering Mathematics</li>
                                        <li>Applicants Chosen Subject</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>Questions Types</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>Multiple Choice-Questions (MCQs)</li>
                                        <li>Multiple Select Questions (MSQs)</li>
                                        <li>Numerical Answer Type (NAT) questions</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>Total Number of Questions</td>
                                <td>65 Questions</td>
                            </tr>
                            <tr>
                                <td>Distribution of Questions in all Papers Excluding AR, CY, DA, EY, GG, MA, PH, ST, XL and XH</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>Engineering Mathematics - 13 Marks</li>
                                        <li>Subject Questions - 72 Marks</li>
                                        <li>General Aptitude - 15 Marks</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>Distribution of Questions in AR, CY, DA, EY, GG, MA, PH, ST, XL and XH</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>85 Questions From Chosen Subject</li>
                                        <li>15 Marks Questions From General Aptitude</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>Total Marks</td>
                                <td>100 Marks</td>
                            </tr>
                            <tr>
                                <td>Marking Scheme</td>
                                <td>All Questions Will Either Carry 1 or 2 Marks</td>
                            </tr>
                            <tr>
                                <td>GATE 2026 Negative Marking</td>
                                <td>
                                    Applicable to MCQs Only, Not MSQs and NATs:
                                    <ul className="list-unstyled">
                                        <li>Deduction of 1/3 For 1 Mark Wrong Response</li>
                                        <li>Deduction of 2/3 For 2 Marks Wrong Response</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h3>GATE 2026 Syllabus</h3>
                    <p>IIT Guwahati released the GATE 2026 Syllabus for all subjects in PDF format on its official website. To stay updated with the latest information on GATE syllabus 2026, applicants are encouraged to regularly check gate2026.iitg.ac.in or bookmark the web portal. Additionally, a comprehensive understanding of the GATE syllabus plays a significant role in developing an effective exam strategy. It provides insights into important topics and concepts, many of which form the basis for the majority of questions in the final exam. Applicants can refer to the branch-wise GATE syllabus for 30 subjects provided here and initiate their studies accordingly until the official announcement of the GATE 2026 syllabus by IIT Guwahati.</p>

                    <h3>GATE 2026 Admit Card</h3>
                    <p>IIT Guwahati will likely release the GATE 2026 Admit Card around two or three weeks before the final exam date. To download the admit card, applicants need to have their enrollment or email ID and password. The following easy-to-follow steps outline the process:</p>
                    <ul className="list-unstyled">
                        <li>Step 1: Visit the GATE 2026 Official Website, i.e., www.iitg.ac.in.</li>
                        <li>Step 2: Locate and click on the GATE 2026 Admit Card Download Link.</li>
                        <li>Step 3: Provide the required details, including enrollment ID, registered email ID, password, and captcha, to log in.</li>
                        <li>Step 4: After entering the details, click on "Submit," and the GATE 2026 Admit Card will be displayed on the screen.</li>
                        <li>Step 5: To save a copy for future reference, click on "Download."</li>
                    </ul>

                    <h3>GATE 2026 Results</h3>
                    <p>Following the successful completion of the GATE 2026 examination, IIT Guwahati will declare the GATE 2026 results for all papers. To access, view, or download their results, applicants can visit the official GATE 2026 website. Moreover, to download the GATE 2026 results, aspirants will be required to enter their registration and enrollment ID exactly as listed in their admit cards. </p>

                    <h3>GATE 2026 Cut Off</h3>
                    <p>The GATE 2026 Cut Off for each paper will be released following the results announcement. It is essential to understand that the GATE 2026 Cut Off will be determined by applicants' performance and can vary depending on factors such as the total number of test takers, the difficulty level of the GATE 2026 question paper, applicant categories, and previous years' GATE Cut Off scores. Qualified applicants will be invited to GATE 2026 counseling based on their scores and cut-off marks. This procedure seeks to simplify admission to renowned universities such as IITs and NITs.</p>

                    <h3>GATE Previous Years Question Paper</h3>
                    <p>Solving the previous year question papers is the essential part of the to refine the preparation for GATE exam. The GATE previous year question papers for GATE serves as the most vital resources that will help candidates familiarize themselves with the exam format, types of questions, and difficulty levels, which are crucial for effective preparation for the upcoming GATE exams.</p>

                    <h3>GATE Online Courses</h3>
                    <p>The online courses cater to the comprehensive study material to prepare effectively for the GATE exam. Candidates aspiring to strengthen their GATE Preparation are advised to join the GATE online coaching by Physics Wallah to explore the organized study material with comprehensive coverage of all the key topics and concepts. The GATE Online Coaching by PW provides interactive live classes, practice sessions, mock tests, and more.</p>

                    <h3>GATE 2026 Online Courses</h3>
                    <p>Kick-start your GATE 2026 Preparation with Physics Wallah’s Online Batches to explore the well-structured curriculum. The GATE Online Batches 2026 will help the aspirant to deep dive into the technical concepts and learn techniques to tackle the challenging questions. Also, the course will provide guidance sessions for aspirants to stay motivated throughout their preparation journey.</p>

                    <h3>GATE 2027 Online Courses</h3>
                    <p>Are you planning to begin the preparation for the GATE 2027 exam? It's the right time to commence your journey with GATE Online Batches 2027 to explore the invaluable study material with free notes, practice sets and mock tests. The online batches for GATE 2027 will offer the detailed coverage of the entire syllabus with regular practice sessions. Aspirants must enroll today to prepare for the exam in an effective manner.</p>

                    <h3>GATE Study Materials</h3>
                    <p>Aspirants preparing for GATE 2026/GATE 2027 are advised to utilize the highly structured study material. Incorporating the relevant study material will boost your preparation for GATE Exam. You can follow the Physics Wallah’s Study Material for GATE including online classes, test series, GATE books, and other resources to aid your preparation.</p>

                    <h3>GATE Online Test Series</h3>
                    <p>Practicing the test series is the most essential part of the GATE preparation. Solving the test series allows aspirants to identify their strengths and weaknesses among the entire syllabus. They can develop the time management skills by incorporating the test series. Physics Wallah offers the relevant test series for all the major branches to help the GATE aspirants to improve their performance. Enroll in the PW Online GATE Test Series for your preparation.</p>

                    <h3>Preparation Tips for GATE Exam- 2026/2027</h3>
                    <p>The GATE is a highly competitive examination that requires a well-structured preparation strategy to cover the entire syllabus effectively. Focused learning, regular practice and dedicated approach will help the students to secure the highest marks. Here are the most effective tips and tricks to ace your GATE Preparation:</p>
                    <ul className="list-unstyled">
                        <li>Begin Preparation Early: Start your preparation well in advance to cover the entire syllabus thoroughly. This approach will help you to allocate a specific time slot to cover the lengthy and tough subjects.</li>
                        <li>Know the GATE Syllabus and Exam Pattern: Familiarize yourself with the GATE syllabus and exam format to optimize your preparation accordingly.</li>
                        <li>Create a Study Plan: Develop a realistic and structured study timetable, allocating the specific time for each subject and including regular revisions and mock tests.</li>
                        <li>Strengthen Your Concepts: Focus on reinforcing the technical concepts, as GATE tests the comprehensive understanding of the core concepts.</li>
                        <li>Practice Regularly: Solve the previous year question papers and take mock tests to know the actual difficulty level of the exam and improve time management skills. </li>
                        <li>Revision: Revise the topics which you have covered periodically to enhance retention and understanding, especially for difficult subjects.</li>
                        <li>Follow Relevant Study Material: Refer to standard textbooks and reliable online resources for comprehensive coverage of topics. Seek guidance from experts to select the appropriate study resources.</li>
                        <li>Join Test Series: Enroll in the test series that offers a variety of questions in accordance with the difficulty level of the exam. GATE Test Series by PW can be a good choice to enhance your GATE preparation.</li>
                    </ul>



                    <h3>IIT GATE Previous Years Question Papers</h3>
                    <p>Physics Wallah provides IIT GATE Previous Years Question Papers for aspirants preparing for the IIT GATE exam. These papers are valuable resources for understanding the exam pattern, difficulty level, and types of questions asked in previous years. By practicing with these papers, students can enhance their problem-solving skills and time management. Physics Wallah provides access to these papers through its platform, helping students prepare well and increase their chances of doing well.</p>
                    <p>The table below provides a collection of IIT GATE previous years' question papers for various disciplines, including Life Sciences, Physical Sciences, Earth Sciences, Chemical Sciences, and Mathematical Sciences. Here is the table providing links to the previous year's question papers for each subjects.</p>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>IIT GATE Previous Years Question Papers Subject Wise</td>
                            </tr>
                            <tr>
                                <td>Year wise</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>Physical Chemistry</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>Inorganic Chemistry</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>Organic Chemistry</td>
                                <td>Click Here</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <Footer />
        </>
    );
}
export default IITGate;